export default "__VITE_ASSET__wNf9MHa$__"